<template>
  <div class="result-menu">
    <div class="default-result-menu">
      <date-button style="margin-left: 10px;" :date="$route.params.date" @change="changeDate" />
      <sport v-for="(sport, i) in sports" :key="sport.id" :ix="i" :sport="sport">
        <m-button
          class="league-button"
          v-for="league in sport.leagues"
          :key="league.id"
          @click="$router.push(`/results/date/${$route.params.date}/sport/${sport.id}/league/${league.id}`)"
        >
          <div class="ellipsis">{{ league.name }}</div>
        </m-button>
      </sport>
    </div>
    <!--div class="compact-result-menu">
      <active-button
        v-for="(sport, i) in sports"
        :key="sport.id"
        line-color="blue"
        line-position="left"
        :active="(!$route.params.sport && !i) || $route.params.sport == sport.id"
        :title="sport.name"
        @click="$router.push(`/results/date/${$route.params.date}/sport/${sport.id}`)"
      >
        <sport-icon :name="sport.alias"></sport-icon>
      </active-button>
    </div-->
  </div>
</template>

<script>
import MButton from '@/components/buttons/MButton'
import ActiveButton from '@/components/buttons/ActiveButton'
import DateButton from '@/components/buttons/DateButton'
import SportIcon from '@/components/icons/SportIcon'
import Sport from '@/components/results/menu/Sport'
import { mapState } from 'vuex'

export default {
  components: {
    MButton,
    ActiveButton,
    DateButton,
    SportIcon,
    Sport
  },
  computed: {
    ...mapState({
      sports: state => state.results.menu
    })
  },
  mounted () {
    this.$store.dispatch('results/GET_MENU', this.$route.params.date)
  },
  methods: {
    changeDate (date) {
      this.$router.push('/results/date/' + date +
        (this.$route.params.sport ? '/sport/' + this.$route.params.sport : ''))
      this.$store.dispatch('results/GET_MENU', this.$route.params.date)
    }
  }
}
</script>

<style scoped>
.default-result-menu { width: 240px; }
.date-button .icon { font-size: 18px; margin: 0 8px -2px 1px; }
.league-button { height: 40px; line-height: 40px; padding: 0 10px; border-radius: 10px; margin-top: 2px; background: white; }
.league-button:last-child { margin-bottom: 2px; margin-top: 2px; }
.compact-result-menu { display: none; }
.compact-result-menu .active-button { height: 40px; padding: 12px; width: 40px; }
</style>

<style>
.left-sidebar-layout.compact .default-result-menu { display: none; }
.left-sidebar-layout.compact .compact-result-menu { display: block; }
</style>



// WEBPACK FOOTER //
// src/components/results/menu/Menu.vue